import React from 'react'
import { SubpageWrapper } from '../subpage-wrapper'

export const Bikes = () => {
    return <SubpageWrapper>Bikes!</SubpageWrapper>
}

export default Bikes
